module.exports = __webpack_public_path__ + "img/87ed4df.jpg";